import React from 'react'
import { majorScale, Pane, Spinner } from 'evergreen-v4'

export default WrappedComponent => props => {
  if (props.isLoading) {
    return (
      <Pane display="flex">
        <Spinner
          size={majorScale(3)}
          flexBasis={majorScale(3)}
          marginY={majorScale(8)}
          marginX="auto"
        />
      </Pane>
    )
  }

  return <WrappedComponent {...props} />
}
